import { TableContainer, Paper, Table, TableBody, TableRow, TableCell } from "@mui/material";
import { useAppSelector } from "../../app/store/configureStore";
import { currencyFormat } from "../../app/util/util";
import { Link } from "react-router-dom";

interface Props {
    isRural: boolean | undefined
    isInternational: boolean
    shippingOption: string
}

export default function ReviewSummary({isRural, isInternational, shippingOption}: Props) {
    
    
    const {basket} = useAppSelector(state => state.basket)

    const subtotal = basket?.items.reduce((sum, item) => sum + (item.price * item.quantity), 0) ?? 0;

    let deliveryFee = 0

    // calculate delivery fee 
    if (isInternational === true) {
        deliveryFee = 4000
    } else {
        if (shippingOption === 'Courier Post' && isRural === true ) {
          deliveryFee = 1220
        } else if (shippingOption === 'Courier Post with signature required' && isRural === true) {
            deliveryFee = 1520
        } else if (shippingOption === 'Courier Post' && isRural !== true) {
            deliveryFee = 720
        } else if (shippingOption === 'Courier Post with signature required' && isRural !== true) {
          deliveryFee = 1020
      }
    }
   
    return (
        <>
            <TableContainer component={Paper} variant={'outlined'}>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell colSpan={2}>Subtotal</TableCell>
                            <TableCell align="right">{currencyFormat(subtotal)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2}>Delivery fee*</TableCell>
                            <TableCell align="right">{currencyFormat(deliveryFee)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2}>Total</TableCell>
                            <TableCell align="right">{currencyFormat(subtotal+ deliveryFee)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                <span style={{fontStyle: 'italic'}}>*Delivery fee has been calculated based on your address and shipping option. You can check our <Link to='/shipping'>shipping fee policy</Link>.</span><br/><br/>
                                <span style={{fontStyle: 'italic'}}>You can check our <Link to='/refund'>Refund policy and care</Link>.</span>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}